import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/components/common/messageservice';

import { Perfis } from '../../../models/perfis';
import { AuthService } from '../../admin/auth.service';

import { WebPage } from '../../shared/web-page';

import { ActivatedRoute, Router } from '@angular/router';
import { HistoricoGeralService } from '../../../services/historico-geral.service';
import { HistoricoGeral } from '../../../models/historico-geral.model';
import { Empresa } from '../../../models/empresa.model';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Unidade } from '../../../models/unidade';

@Component({ templateUrl: './historico-alteracao.component.html',styleUrls: ['./historico-alteracao.component.scss'] })
export class HistoricoAlteracaoComponent extends WebPage implements OnInit {
  alteracoes : Array<HistoricoGeral<any>> = [];
  form: FormGroup = {} as FormGroup;
  perfis: any = {};
  isLoading: boolean = false;

  //dados para modal
  alteracaoModal: HistoricoGeral<any> = null;
  alteracaoModalAnterior: HistoricoGeral<any> = null;
  modalJustificativaAtual = false;
  modalVagasAtual = false;

  usuario: any = {};
  idProposta: string = null;
  unidades : Array<Unidade> = [];

  constructor(
    messageService: MessageService,
    private authService: AuthService,
    private _router: Router,
    private route: ActivatedRoute,
    private _historicoService: HistoricoGeralService,
    private _unidadeService: UnidadeService
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.idProposta = this.route.snapshot.paramMap.get('id');
    this.perfis = Perfis;
    this.buscarHistorico();
    this.buscarUnidades();
  }

  buscarHistorico() {
    this._historicoService.getHistoricoProposta(this.idProposta).subscribe((v)=>{
      
      const alt: Array<HistoricoGeral<any>> = v.map((value)=> {

        const res: HistoricoGeral<any> = {
          dataOperacao: value.dataOperacao,
          tipoHistorico: value.tipoHistorico,
          idHistorico : value.idHistorico,
          operacao : value.operacao,
          usuarioAlteracao : value.usuarioAlteracao,
          dados : JSON.parse(value.dados) as Empresa
        };
        return res;
      })

      this.alteracoes = alt.sort((a,b)=> {
        if(a.dataOperacao > b.dataOperacao){
          return -1
        } else if(a.dataOperacao < b.dataOperacao){
          return 1;
        }
        return 0;
      });
      this.isLoading = false;
    },(error) => {
      this.isLoading = false;
      this.gerenciaErro(error)
    })
  }

  substituirValorVazio(valor: any){
    if(valor=== ""|| valor === null || valor === undefined){
      return "-"
    }
    return valor;
  }

  buscarUnidades(){
    this._unidadeService.getUnidades().subscribe((res) => {
      this.unidades = res;
    });
  }

  getUnidadeById(idUnidade : string): Unidade | undefined{
    return this.unidades.find((v) => v.idUnidade === idUnidade)
  }

  abrirModalDetalhes(alteracaoSelecionada : any, index: number) {
    this.alteracaoModal = alteracaoSelecionada;
    if(this.alteracoes.length > 1 && index !== this.alteracoes.length - 1){
      this.alteracaoModalAnterior = this.alteracoes[index + 1];
      this.modalVagasAtual = false;
      this.modalJustificativaAtual = false;
    } else{
      this.alteracaoModalAnterior = null;
      this.modalVagasAtual = true;
      this.modalJustificativaAtual = true;
    }
  }

  formatDateText(date: string){

    const dataObj = new Date(date);
    if(dataObj){
      const optionsDate = {
        year: "numeric",
        month: "long",
        day: "2-digit",
      };
  
      const optionsHour = {
        hour: "2-digit",
        minute: "2-digit"
      };
  
      const dataPorExtenso = dataObj.toLocaleDateString("pt-BR", optionsDate);
      const hora = dataObj.toLocaleTimeString("pt-BR", optionsHour);

      return dataPorExtenso + " às " + hora
    }
    
    return "-"
  }

  alterarAtualAntigo(tipo: string, atual: boolean){
    if(tipo === "justificativa"){
      this.modalJustificativaAtual = atual;
    } else{
      this.modalVagasAtual = atual;
    }
  }

  formatCategoria(arrayCategoria: Array<any>){
    if(arrayCategoria == null || arrayCategoria == undefined || arrayCategoria.length === 0){
      return "-";
    } 

    const arrayCategoriaSeparadas = arrayCategoria.map((v)=>{
      return v.Categoria
    })

    let categorias = "";

    arrayCategoriaSeparadas.forEach((categoria, i) => {
      if(categoria !== null && categoria !== undefined){
        let separador = i == 0 ? "" : ", "
        categorias += separador + categoria.Descricao.split(" ")[1];
      }
    });

    return categorias;
  }

  voltar() {
    this._router.navigate(['/gerenciar-vagas']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/proposta/historicoAlteracao/historico-alteracao.component.ts